// @ts-ignore: our current Ember Data types don't cover this properly
import JSONAPICache from '@ember-data/json-api';

import isEqual from 'lodash.isequal';

interface AttributeSchema {
  kind: 'attribute';
  name: string;
  options: {
    [key: string]: any;
  };
  type: string;
}

export default class CIOJSONAPICache extends JSONAPICache {
  getAttributeDefinition(id: any, key: string): AttributeSchema | null {
    // TODO: using legacy __storeWrapper, look for alternatives
    let definitions = (this as any).__storeWrapper
      .getSchemaDefinitionService()
      .attributesDefinitionFor({ type: id.type });

    if (definitions == null) {
      return null;
    }

    return definitions[key];
  }

  isArrayAttribute(id: any, key: string) {
    let definition = this.getAttributeDefinition(id, key);

    return definition?.type === 'array';
  }

  // override of https://github.com/emberjs/data/blob/860a781264e0c951a7c9a5fe927d79ff7faca061/packages/json-api/src/-private/cache.ts#L925
  // lodash.isEqual for equality checks on "array" attrs:
  //
  // disabling ESLint rules to stay closer to the original code:
  /* eslint-disable ember-suave/no-const-outside-module-scope */
  /* eslint-disable @typescript-eslint/strict-boolean-expressions */
  setAttr(identifier: any, attr: string, value: unknown): void {
    // @ts-ignore
    const cached = this.__peek(identifier, false);
    const existing =
      cached.inflightAttrs && attr in cached.inflightAttrs
        ? cached.inflightAttrs[attr]
        : cached.remoteAttrs && attr in cached.remoteAttrs
          ? cached.remoteAttrs[attr]
          : undefined;

    // THE CUSTOM PART:
    let equal = this.isArrayAttribute(identifier, attr) ? isEqual(existing, value) : existing === value;
    if (!equal) {
      cached.localAttrs = cached.localAttrs || Object.create(null);
      cached.localAttrs![attr] = value;
      cached.changes = cached.changes || Object.create(null);
      cached.changes![attr] = [existing, value];
    } else if (cached.localAttrs) {
      delete cached.localAttrs[attr];
      delete cached.changes![attr];
    }

    // @ts-ignore
    this.__storeWrapper.notifyChange(identifier, 'attributes', attr);
  }
}
